import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AfericaoServicoInicialService } from 'src/app/modules/shared/afericao-servico-Inicial/afericao-servico-inicial.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take, finalize, Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { AprovarAnaliseComponent } from 'src/app/modules/shared/modals/aprovar-analise/aprovar-analise.component';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import * as moment from 'moment';
import { AtendidoAnaliseComponent } from 'src/app/modules/shared/modals/atendido-analise/atendido-analise.component';
import { HistoricoAnaliseComponent } from 'src/app/modules/shared/modals/historico-analise/historico-analise/historico-analise.component';
import { ModalController } from '@ionic/angular';
import { ModalViewRelatoriooVinculadosComponent } from 'src/app/modules/shared/modals/modal-view-relatorioo-vinculados/modal-view-relatorioo-vinculados.component';
import { AlertComponent } from 'src/app/modules/components/alert/alert.component';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { ModalComponent } from 'src/app/modules/components/modal/modal.component';

@Component({
  selector: 'app-detail-afericao-inicial',
  templateUrl: './detail-afericao-inicial.component.html',
  styleUrls: ['./detail-afericao-inicial.component.scss']
})
export class DetailAfericaoInicialComponent implements OnInit {
  idAfericao: string = '';
  afericao: any;
  selectedTabDetalhes = 0;

  // Subscriptions
  subscriptions: Subscription[] = [];

  // Screen width
  screenWidth: number = window.innerWidth;

  // === TABELA: Documentos Assinados ===
  sortState = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc'
  };

  columnConfig = [
    { columnDef: 'protocolo', header: 'Protocolo', property: 'protocoloContrato.numeroProtocolo' },
    { columnDef: 'descricao', header: 'Descrição', property: 'comentario' },
    { columnDef: 'dataUltimaAssinatura', header: 'Data de assinatura', property: 'dataUltimaAssinatura', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true }
  ];

  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [];
  pageIndex = 0;
  pageSize = 10;
  totalPages = 1;
  totalElements = 0;

  // === TABELA: Análise Aferição ===
  sortStateAnalise = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc'
  };

  columnConfigAnalise = [
    { columnDef: 'protocolo', header: 'Protocolo', property: 'analiseAfericao.protocoloContrato.numeroProtocolo' },
    { columnDef: 'tipo', header: 'Tipo', property: 'tipoAnalise.nome' },
    { columnDef: 'descricao', header: 'Descrição', property: 'descricao' },
    { columnDef: 'responsavel', header: 'Responsável', property: 'usuario.nome' },
    { columnDef: 'prazo', header: 'Prazo', property: 'prazo', customTd: true },
    { columnDef: 'statusAtual', header: 'Status', property: 'statusAtual', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true }
  ];

  dataSourceAnalise = new MatTableDataSource<any>();
  displayedColumnsAnalise: string[] = [];
  pageIndexAnalise = 0;
  pageSizeAnalise = 10;
  totalPagesAnalise = 1;
  totalElementsAnalise = 0;
  screenWidthAnalise: number = window.innerWidth;

  // === TABELA: Documentos para Assinar ===
  sortStateAssinar = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc'
  };

  columnConfigAssinar = [
    { columnDef: 'protocolo', header: 'Protocolo', property: 'documentoComprovacao.protocoloContrato.numeroProtocolo' },
    { columnDef: 'comentario', header: 'Descrição', property: 'documentoComprovacao.comentario' },
    { columnDef: 'assinante', header: 'Assinante', property: 'usuario.nome' },
    { columnDef: 'dataAssinatura', header: 'Data de Assinatura', property: 'dataAssinatura', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true }
  ];

  dataSourceAssinar = new MatTableDataSource<any>();
  displayedColumnsAssinar: string[] = [];
  pageIndexAssinar = 0;
  pageSizeAssinar = 10;
  totalPagesAssinar = 1;
  totalElementsAssinar = 0;

  // === Filtros / Outros dados ===
  arrayStatus: any = [
    { label: "Todos", property: "" },
    { label: "Pendente de comprovação", property: "" },
    { label: "Comprovação enviada", property: "" },
    { label: "Em análise", property: "" },
    { label: "Parâmetro atestado", property: "" },
    { label: "Aguardando complementação das informações", property: "" },
  ];

  idDocumentoPendente: any;
  idUser: any;

  // === CONSTRUTOR ===
  constructor(
    private route: ActivatedRoute,
    private afericaoServicoInicialService: AfericaoServicoInicialService,
    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,
    private router: Router,
    private pageSizeService: PageSizeService,
    public dialog: MatDialog,
    private toastService: ToastService,
    private modalCtrl: ModalController,
  ) {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.idAfericao = params.get('id') ?? '';
      this.getData(this.idAfericao);
      this.getDataAnaliseAfericao(0, this.idAfericao);
      this.getDataDocumentsAssinados(0, this.idAfericao);
      this.getDataDocumentsPendentes(0, this.idAfericao);
    });
  }

  ngOnInit(): void {
    this.displayedColumns = this.columnConfig.map(col => col.columnDef);
    this.displayedColumnsAssinar = this.columnConfigAssinar.map(col => col.columnDef);
    this.displayedColumnsAnalise = this.columnConfigAnalise.map(col => col.columnDef);
  }

  // Expande os dados para exibir linha de detalhe na tabela
  getExpandedData(data: any[]): any[] {
    return data.flatMap(row => [row, { detailRow: true, ...row }]);
  }

  // Requisição da aferição inicial
  getData(idAfericao: string): void {
    this.afericaoServicoInicialService
      .getAfericaoInicial(idAfericao)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (res: any) => {
          this.afericao = res;
        },
        error: (erro: any) => this.handleRequestError(erro)
      });
  }

  // Requisição de análises de aferição com paginação e ordenação
  getDataAnaliseAfericao(pageIndex: number = 0, idParametroServicoInicial: string): void {
    this.afericaoServicoInicialService
      .getAnaliseAfericoes(
        this.pageSizeAnalise,
        pageIndex,
        this.sortStateAnalise.sortDirection,
        this.sortStateAnalise.sortProperty,
        idParametroServicoInicial
      )
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (res: any) => {
          const {
            content,
            pageSize,
            totalPages,
            totalElements,
            pageNumber
          } = res;

          this.dataSourceAnalise.data = this.getExpandedData(content);
          this.pageSizeAnalise = pageSize;
          this.totalPagesAnalise = totalPages;
          this.totalElementsAnalise = totalElements;
          this.pageIndexAnalise = pageNumber;
        },
        error: (erro: any) => this.handleRequestError(erro)
      });
  }

  // Tratamento centralizado de erros de requisição
  private handleRequestError(erro: any): void {
    if (erro.status !== 500 && erro.status) {
      this.openSnackBar(erro.error.message, 'error');
    } else if (erro.error?.error === 'Unprocessable Entity') {
      this.openSnackBar(erro.error.message, 'warning');
    } else {
      this.openSnackBar(
        'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
        'error'
      );
    }
  }

  // === DOCUMENTOS ASSINADOS ===
  getDataDocumentsAssinados(pageIndex: number = 0, idParametroServicoInicial: string): void {
    this.afericaoServicoInicialService
      .getDocumentosAssinados(
        this.pageSize,
        pageIndex,
        this.sortState.sortDirection,
        this.sortState.sortProperty,
        idParametroServicoInicial
      )
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (res: any) => {
          const {
            content,
            pageSize,
            totalPages,
            totalElements,
            pageNumber
          } = res;

          this.dataSource.data = content;
          this.pageSize = pageSize;
          this.totalPages = totalPages;
          this.totalElements = totalElements;
          this.pageIndex = pageNumber;
        },
        error: (erro: any) => this.handleRequestError(erro)
      });
  }

  // === DOCUMENTOS PENDENTES PARA ASSINATURA ===
  getDataDocumentsPendentes(pageIndex: number = 0, idParametroServicoInicial: string): void {
    this.afericaoServicoInicialService
      .getDocumentosPendentes(
        this.pageSizeAssinar,
        pageIndex,
        this.sortStateAssinar.sortDirection,
        this.sortStateAssinar.sortProperty,
        idParametroServicoInicial
      )
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (res: any) => {
          const {
            content,
            pageSize,
            totalPages,
            totalElements,
            pageNumber
          } = res;

          this.dataSourceAssinar.data = content;
          this.pageSizeAssinar = pageSize;
          this.totalPagesAssinar = totalPages;
          this.totalElementsAssinar = totalElements;
          this.pageIndexAssinar = pageNumber;
        },
        error: (erro: any) => this.handleRequestError(erro)
      });
  }

  // === SNACKBAR DE ALERTA ===
  openSnackBar(description: string, type: string): void {
    const classMap: Record<string, string> = {
      sucess: 'snacbar-sucess',
      warning: 'snacbar-warning',
      error: 'snacbar-error'
    };

    const classSnack = classMap[type] || 'snacbar-default';

    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description, type },
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }

  // === FORMATADOR ===
  getMedidaFormatada(valor: number, medida: string): string {
    if (!medida || valor == null) return '';

    const medidaLower = medida.toLowerCase();

    const singularMap: Record<string, string> = {
      dias: 'Dia',
      meses: 'Mês',
      anos: 'Ano',
      horas: 'Hora'
    };

    return valor === 1 || valor < 1
      ? singularMap[medidaLower] || medidaLower
      : medida;
  }

  // === NAVEGAÇÃO ===
  close(): void {
    this.router.navigate(['afericoes']);
  }
 // === ORDENAÇÃO ===
  onSortChangeAnalise(sortProperty: string): void {
    if (this.sortStateAnalise.sortProperty === sortProperty) {
      this.sortStateAnalise.sortDirection =
        this.sortStateAnalise.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortStateAnalise.sortProperty = sortProperty;
      this.sortStateAnalise.sortDirection = 'asc';
    }

    // Requisição pode ser disparada aqui se necessário
    this.getDataAnaliseAfericao(0, this.idAfericao);
  }

  // === PAGINAÇÃO ===
  pageChangeEventAnalise(event: PageEvent): void {
    const { pageIndex, pageSize } = event;

    if (this.pageSizeAnalise !== pageSize) {
      this.pageSizeAnalise = pageSize;
      this.pageSizeService.setPageSize(pageSize);
      this.getDataAnaliseAfericao(0, this.idAfericao);
      return;
    }

    if (this.pageIndexAnalise !== pageIndex) {
      this.getDataAnaliseAfericao(pageIndex, this.idAfericao);
      
    }
  }
onSortChange(sortProperty: string, from: 'assinado' | 'assinar' = 'assinado'): void {
  // 1. Define qual estado manipular dinamicamente
  const state = from === 'assinado' ? this.sortState : this.sortStateAssinar;

  // 2. Lógica de alternância de direção ou troca de propriedade
  if (state.sortProperty === sortProperty) {
    state.sortDirection = state.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    state.sortProperty = sortProperty;
    state.sortDirection = 'asc';
  }

  // 3. Gatilho de busca unificado
  this.refreshData(0, from);
}

pageChangeEvent(event: PageEvent, from: 'assinado' | 'assinar' = 'assinado'): void {
  const { pageIndex, pageSize } = event;

  if (this.pageSize !== pageSize) {
    this.pageSize = pageSize;
    this.pageSizeService.setPageSize(pageSize);
    this.refreshData(0, from);
    return;
  }

  if (this.pageIndex !== pageIndex) {
    this.refreshData(pageIndex, from);
  }
}
private refreshData(page: number, from: string): void {
  this.pageIndex = page; // Atualiza o índice global se necessário

  if (from === 'assinado') {
    this.getDataDocumentsAssinados(page, this.idAfericao);
  } else {
    this.getDataDocumentsPendentes(page, this.idAfericao);
  }
}

  // === MODAL DE EXCLUSÃO ===
  openDialogDelete(event: any): void {
    const id = event;
    const document = this.dataSourceAssinar.data.find(item => item.id === id);

    if (!document?.documentoComprovacao?.id) return;

    this.idDocumentoPendente = document.documentoComprovacao.id;

    this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirm.bind(this),
        modalTitle: 'Excluir',
        modalContent: 'Você tem certeza que deseja excluir esta Assinatura?'
      }
    });
  }

  // === CONFIRMAÇÃO DE EXCLUSÃO ===
  onDeleteModalConfirm(): void {
    this.afericaoServicoInicialService
      .deleteAssinaturaPendente(this.idAfericao, this.idDocumentoPendente)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: () => {
          this.openSnackBar('Documento assinado com sucesso!', 'sucess');
          this.getDataDocumentsAssinados(0, this.idAfericao);
          this.getDataDocumentsPendentes(0, this.idAfericao);
        },
        error: (erro: any) => this.handleRequestError(erro)
      });
  }

  // === MODAL DE ASSINATURA ===
  openDialogAssinar(event: any): void {
    this.idDocumentoPendente = event.id;
    this.idUser = event.userId;

    this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onSignModalConfirm.bind(this),
        modalTitle: 'Confirmação de Assinatura Digital',
        modalContent: 'Você está prestes a assinar digitalmente este documento. Deseja continuar?',
        btnSaveLabel: 'Confirmar Assinatura'
      }
    });
  }

  // === CONFIRMAÇÃO DE ASSINATURA ===
  onSignModalConfirm(): void {
    this.afericaoServicoInicialService
      .assinarDocumento(this.idAfericao, this.idDocumentoPendente)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: () => {
          this.openSnackBar('Documento assinado com sucesso!', 'sucess');
          this.getDataDocumentsAssinados(0, this.idAfericao);
          this.getDataDocumentsPendentes(0, this.idAfericao);
        },
        error: (erro: any) => this.handleRequestError(erro)
      });
  }

  // === ABERTURA DE VISUALIZAÇÃO DE DOCUMENTO ===
  openView(id: any, from: string): void {
    let document;

    if (from === 'assinar') {
      document = this.dataSourceAssinar.data.find(item => item.id === id);
      if (!document?.documentoComprovacao?.id) return;

      this.router.navigate([
        `documento-comprovacao/inicial/${this.idAfericao}/${document.documentoComprovacao.id}/view`
      ]);
    } else {
      document = this.dataSource.data.find(item => item.id === id);
      if (!document?.id) return;

      this.router.navigate([
        `documento-comprovacao/inicial/${this.idAfericao}/${document.id}/view`
      ]);
    }
  }

  // === TRANSIÇÃO DE STATUS (EVENTO DE MUDANÇA) ===
  transitionStatusChanged(event: any): void {
    if (!event || !event.data) {
      console.warn('Evento inválido:', event);
      return;
    }

    const idAnaliseAfericao = event.data.id;
    const statusAtualId = event.data.status?.statusAtual?.id;
    const transicaoId = event.transicaoId;

    switch (event.transicaoNome) {
      case 'Encaminhar para aprovação':
        this.openAnalyzeDialog(idAnaliseAfericao, statusAtualId, transicaoId);
        break;

      case 'Solicitar complementação':
        // Lógica futura
        this.openAtendidoAnalyzeDialog(idAnaliseAfericao, statusAtualId, transicaoId, event);
        break;

      case 'Atendido':
        this.openAtendidoAnalyzeDialog(idAnaliseAfericao, statusAtualId, transicaoId, event);
        break;

      case 'Encaminhar para análise':
           if(event.data.status?.statusAtual?.nome == 'Aguardando revisão'){
                this.openAnalyzeDialog(idAnaliseAfericao, statusAtualId, transicaoId, true);
            }else{
                this.openAnalyzeDialog(idAnaliseAfericao, statusAtualId, transicaoId);
            }
        break;

      default:
        console.warn('Ação de transição não reconhecida:', event);
        break;
    }
  }

  // === ABERTURA DE MODAL DE ANÁLISE ===
  openAnalyzeDialog(
    idAnaliseAfericao: string,
    statusAtualId: string,
    transicaoId: string,
    isAguardandoRevisao: boolean = false
  ): void {
    const { id, cnpj } = this.afericao.contrato.company;

    const dialogRef = this.dialog.open(AprovarAnaliseComponent, {
      width: '1550px',
      data: {
        idAnaliseAfericao: idAnaliseAfericao,
        statusAtualId: statusAtualId,
        transicaoId: transicaoId,
        isAguardandoRevisao:isAguardandoRevisao,
        idEntidade: id,
        cnpj: cnpj
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.transitionStatus(result);
      }
    });
  }
  // === ABERTURA DE MODAL DE ANÁLISE ===
  openAtendidoAnalyzeDialog(
    idAnaliseAfericao: string,
    statusAtualId: string,
    transicaoId: string,
    data: any,
  ): void {
    const { id, cnpj } = this.afericao.contrato.company;
    const transicaoNome = data.transicaoNome;
    const dialogRef = this.dialog.open(AtendidoAnaliseComponent, {
      width: '856px',
      data: {
        idAnaliseAfericao: idAnaliseAfericao,
        statusAtualId: statusAtualId,
        transicaoId: transicaoId,
        idEntidade: id,
        transicaoNome: transicaoNome,
        statusAtual:data.data.statusAtual,
        cnpj: cnpj
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.transitionStatus(result);
      }
    });
  }

  // === ENVIO DE TRANSIÇÃO DE STATUS ===
  transitionStatus(formData?: any): void {
    this.loadingService.showLoading();

    this.afericaoServicoInicialService
      .postTransicaoStatusAnalise(this.idAfericao, formData)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: () => {
          this.getDataAnaliseAfericao(0, this.idAfericao);
          this.toastService.showSuccess('Mudança de status realizada com sucesso');
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        }
      });
  }

  // === EXPANSÃO DE LINHA DA TABELA DE ANÁLISE ===
  rowExpanded(event: any): void {
    this.afericaoServicoInicialService
      .getDetalhesItemAnalise(this.idAfericao, event.id)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (res: any) => {
          const item = this.dataSourceAnalise.data.find(analise => analise.id === event.id).analises = res;
        },
        error: (erro: any) => this.handleRequestError(erro)
      });
  }
  async openDialogHistoricoAnalise(event: any) {

    let data;
    const item = this.dataSourceAnalise.data.filter(analise => (analise.id == event) && !analise.detailRow);
    if (item) {
      data = {
        alteracoes:[],
        autor: "Usuário Master",
        data:"2025-06-18T17:15:19.297Z",
        operacao:"Registro incluído",
    
    }
      // const modal = await this.modalCtrl.create({
      //   component: HistoricoAnaliseComponent,
      //   componentProps: {
      //     dataSourceData: data,
      //   },
      // });

      // modal.present();
    }
  }
  openViewAnalise(event:any){
    this.router.navigate([`detail-afericao/${this.idAfericao}/${event.data.id}/${event.idAnalise}/inicial/view`]);
  }
  openRelatoriosVinculado(event:any){
    const dialogRef = this.dialog.open(ModalViewRelatoriooVinculadosComponent, {
        width: '700px',
        data: {
          analiseAfericaoId:event,
          afericaoId:this.idAfericao
        }
      });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
}